import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=61dd80d5"
import script from "./PlanList.js?vue&type=script&lang=js&external"
export * from "./PlanList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports